'use client';

import { useTranslation } from '@root/src/i18n/client';
import Image from '@components/common/ImageFallback';
import vienImg from '@src/assets/images/vien.png';

interface CollectionTitleProps {
  collection: {
    name: string;
    description?: string;
  };
}

export default function CollectionTitle({ collection }: CollectionTitleProps) {
  const { t } = useTranslation('common');

  return (
    <div className="collection-title">
      <div className="icon-leaf">
        <Image src={vienImg} alt="leaf" width={222} height={222} />
      </div>
      <h2 className="title">{collection.name}</h2>
      <div className="divider" />
      <p className="desc">
        {collection.description || t('lytra.collectionTitleFallbackDesc')}
      </p>

      <style jsx>{`
        .collection-title {
          text-align: center;
          padding: 12px 18px 10px;
          margin-top: -18px;
          background: #faf7f2;
          font-family: Georgia, 'Times New Roman', serif;
          position: relative;
          z-index: 1;
        }
        .icon-leaf {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          margin-bottom: 2px;
        }
        .icon-leaf :global(img) {
          width: clamp(92px, 14vw, 150px);
          height: auto;
        }
        .title {
          font-family: Georgia, 'Times New Roman', serif;
          font-size: 34px;
          font-weight: 700;
          color: #2c2218;
          margin: 0 0 10px;
          overflow-wrap: anywhere;
          line-height: 1.08;
        }
        .divider {
          width: 60px;
          height: 2px;
          background: linear-gradient(90deg, transparent, #c9a96e, transparent);
          margin: 0 auto 14px;
        }
        .desc {
          font-size: 14px;
          color: #6b5d4f;
          line-height: 1.7;
          margin: 0 auto;
          max-width: 760px;
          white-space: pre-line;
        }
        @media (min-width: 768px) {
          .collection-title {
            padding: 16px 32px 14px;
            margin-top: -28px;
          }
          .title {
            font-size: 42px;
            margin-bottom: 12px;
          }
          .divider {
            margin-bottom: 16px;
          }
        }
        @media (max-width: 767px) {
          .collection-title {
            margin-top: -14px;
          }
          .title {
            font-size: 30px;
          }
        }
      `}</style>
    </div>
  );
}
